import React, { Component } from "react";
import { Container, Col, Row } from "react-bootstrap";

// style
import "./style.scss";

class HowtobeBorrower extends Component {
  constructor(props) {
    super(props);

    this.state = {
      index: 0,
    };
  }
  render() {
    return (
      <div className="py-5">
        <Container>
          <h1 className="font-weight-bold text-center">
            Cara Pengajuan Modal Usaha
          </h1>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <div
                className="mt-4"
                style={{
                  position: "relative",
                  paddingBottom: "56.25%" /* 16:9 */,
                  paddingTop: 25,
                  height: 0,
                }}
              >
                <iframe
                  title="Cara Pengajuan Modal Usaha"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                  }}
                  src={`https://www.youtube.com/embed/ivKdZUGHD-g`}
                  frameBorder="0"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default HowtobeBorrower;
